import { ui } from "../../common";
import { useMemo, useState } from "react";
import { DashboardCustomerSpend } from "../../dtos";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell
} from 'recharts';

import testData from "./test-chart-data"

interface Props {
    data: DashboardCustomerSpend[];
}

export default function CustomerSpendChart({ data }: Props) {
    const [count, setCount] = useState(10);

    console.log(data);
    const chartData = useMemo(() => {
        return [...data]
            .sort((a, b) => b.callSpend - a.callSpend) // Sort descending
            .slice(0, count); // Get top 20 for better readability
    }, [data, count]);

    // 2. Custom formatter for currency
    const formatCurrency = (value) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);

    const chartHeight = `${(chartData.length * 45) + 100}px`;
    return (<>
        <ui.Form layout="inline">
            <ui.Form.Item label="# Customers">
                <ui.Select value={count} onChange={ev => setCount(ev)}>
                    <ui.Select.Option value={10}>10</ui.Select.Option>
                    <ui.Select.Option value={25}>25</ui.Select.Option>
                    <ui.Select.Option value={50}>50</ui.Select.Option>
                    <ui.Select.Option value={5000}>All</ui.Select.Option>
                </ui.Select>
            </ui.Form.Item>
        </ui.Form>
        <div style={{ width: '100%', height: chartHeight, backgroundColor: '#fff', padding: '20px', borderRadius: '8px' }}>
            <h2 style={{ textAlign: 'center', fontFamily: 'sans-serif' }}>Call Spend by Customer (Top {count})</h2>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={chartData}
                    layout="vertical" // Essential for horizontal bars
                    margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
                    barSize={60}
                    barGap={10}
                >
                    <CartesianGrid strokeDasharray="3 3" horizontal={false} />

                    {/* XAxis shows the spend amount */}
                    <XAxis type="number" tickFormatter={formatCurrency} />

                    {/* YAxis shows the customer names */}
                    <YAxis
                        dataKey="customerName"
                        type="category"
                        width={100}
                        interval={0}
                        tick={{ fontSize: 12 }}
                    />

                    <Tooltip
                        formatter={(value) => formatCurrency(value)}
                        cursor={{ fill: '#f5f5f5' }}
                    />

                    <Bar dataKey="callSpend" radius={[0, 4, 4, 0]}>
                        {chartData.map((entry, index) => (
                            // Highlight the #1 spender with a different color
                            <Cell key={`cell-${index}`} fill={index === 0 ? '#4f46e5' : '#8884d8'} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    </>
    );
}